import React from "react";
import { IoSend } from "react-icons/io5";
import InlineLoader from "../../components/loader/InlineLoader";
import Button from "../../components/ui/Button";

const MessageInput = ({
  message,
  handleMessageChange,
  handleSendMessage,
  handleKeyPress,
  disabled = false,
  isSending = false,
}) => {
  return (
    <div className="p-3 border-t border-gray-200 flex items-center space-x-2 bg-gray-100">
      <input
        className={`flex-1 bg-white rounded-full py-2 px-4 outline-none ${
          disabled ? "bg-gray-100 text-gray-400" : ""
        }`}
        placeholder={disabled ? "Connecting to chat..." : "Type a message"}
        value={message}
        onChange={handleMessageChange}
        onKeyPress={handleKeyPress}
        disabled={disabled} // Removed isSending check to allow input during sending
      />
      <Button
        className={`rounded-full ${
          disabled
            ? "text-gray-400 cursor-not-allowed"
            : "text-blue-600 hover:bg-gray-200"
        }`}
        variant={"ghost"}
        size={"icon"}
        onClick={handleSendMessage}
        disabled={disabled} // Removed isSending check here as well
      >
        {/* {isSending ?  */}
        {/* <InlineLoader className="w-6 h-6 text-gray-400" /> :  */}
        <IoSend className="w-6 h-6" />
        {/* } */}
      </Button>
    </div>
  );
};

export default MessageInput;
